export enum ForbiddenReason {
  ResponseByPermission = "forbiddenResponseByPermission",
}
